/* eslint-disable no-console */
export default (name: string, debug?: boolean) => {
  return debug ? console.log.bind(console, `[${name}]: %s`) : () => {};
};
